module.exports = __webpack_public_path__ + "media/images/bg/yellow-line-7ba9279ab9a276e9defff91a6d3c8fce.svg";